import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LogoDark } from "./Logo";
import { api } from "@/lib/api";

export default function Footer() {
  const [islands, setIslands] = useState([]);
  useEffect(() => {
    api.get("/islands").then((r) => setIslands(r.data)).catch(() => setIslands([]));
  }, []);

  return (
    <footer className="bg-navy-deep text-offwhite mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2 space-y-6">
          <LogoDark />
          <p className="text-offwhite/70 max-w-md leading-relaxed text-sm">
            LocalRida connects arriving travelers with vetted licensed private
            transfer operators. Premium, discreet, on time — from airport to hotel, villa, or vacation rental,
            and everywhere in between.
          </p>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-gold-bright mb-4">Destinations</div>
          <ul className="space-y-2 text-sm" data-testid="footer-islands">
            {islands.length === 0 ? (
              <li className="text-offwhite/40">Loading destinations…</li>
            ) : islands.map((i) =>
              i.active ? (
                <li key={i.slug}>
                  <Link
                    to={`/${i.slug}`}
                    className="hover:text-gold-bright transition-colors"
                    data-testid={`footer-island-${i.slug}`}
                  >
                    {i.name}
                  </Link>
                </li>
              ) : (
                <li
                  key={i.slug}
                  className="text-offwhite/40"
                  data-testid={`footer-island-${i.slug}`}
                >
                  {i.name} — coming soon
                </li>
              )
            )}
          </ul>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-gold-bright mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/how-it-works" className="hover:text-gold-bright transition-colors" data-testid="footer-how">How It Works</Link></li>
            <li><Link to="/contact" className="hover:text-gold-bright transition-colors" data-testid="footer-contact">Contact</Link></li>
            <li><Link to="/privacy" className="hover:text-gold-bright transition-colors" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-gold-bright transition-colors" data-testid="footer-terms">Terms of Service</Link></li>
            <li><Link to="/login" className="hover:text-gold-bright transition-colors text-offwhite/50" data-testid="footer-admin">Operator Portal</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-navy-soft/60">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-offwhite/50">
          <div>© {new Date().getFullYear()} LocalRida. All rights reserved.</div>
          <div className="uppercase tracking-[0.2em]">Licensed operators only · Calls may be recorded</div>
        </div>
      </div>
    </footer>
  );
}
